import { render, staticRenderFns } from "./CrmFunnelPopupWrappable.vue?vue&type=template&id=187aeba3&lang=pug&"
import script from "./CrmFunnelPopupWrappable.vue?vue&type=script&lang=js&"
export * from "./CrmFunnelPopupWrappable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports